import { observer } from "mobx-react";
import ContentState from "../../../../stores/ContentState";
import { Visitor } from "../Intro";
import "./index.scss";
import { ReactComponent as Logo } from "../../../../assets/career/Vector.svg";
import GlobalState from "../../../../stores/GlobalState";
const About = observer(() => {
  if (!ContentState.career.about) return <></>;
  const about = ContentState.career.about;

  let cultureLink = "";

  const lang = GlobalState.currentLocale.lang.includes("Eng")
    ? "/en/"
    : GlobalState.currentLocale.lang.includes("ру")
    ? "/ru/"
    : "/";
  cultureLink = `${lang}career/culture`;

  return (
    <section className="about-career">
      <div className="about-career__img">
        <Logo />
        {about.imgs.map((im: any, i: number) => (
          <div className="about-career__small-img" key={i}>
            <img src={im} />
          </div>
        ))}
      </div>
      <div className="about-career__col">
        <div className="about-career__title">
          {about.subtitle} {Visitor.name.length ? Visitor.name : about.title}!
        </div>
        <div
          className="about-career__text"
          dangerouslySetInnerHTML={{ __html: about.text }}
        ></div>
        <a className="button black" href={cultureLink}>
          {window.innerWidth > 480 ? about?.button : about?.buttonMob}
        </a>
      </div>
    </section>
  );
});

export default About;
